import zod from 'zod'

export const schema = zod.object({
  name: zod
    .string({ required_error: 'Obrigatório' })
    .min(3, 'Deve ter no mínimo 3 letras'),
  email: zod
    .string({ required_error: 'Obrigatório' })
    .email('Deve ser um e-mail válido'),
  password: zod.string().trim().min(8, 'Deve ter no mínimo 8 caracteres'),
  role: zod.enum(['owner', 'client'] as const, {
    errorMap: () => ({ message: 'Obrigatório' }),
  }),
})

export type CreateAdminFormType = zod.infer<typeof schema>
